import React, { useEffect, useState } from "react";
import Routes from "Routes";
import ROUTE_PATH from "Routes/paths";
import { ChangeHistory, EventManager, LanguageContext } from "utils";
import { Button, FlexBox, Footer, LanguageSupport, Loader } from "components";
import { setGeneralDetails, useGeneralDetails } from "Slices";
import { globalConstant } from "./constants";
import { useDispatch } from "react-redux";
import store from "store";
import ReactGA from "react-ga4";

const App: React.FC = () => {
  //Dispatch
  const dispatch = useDispatch();

  //Constants
  const [defaultLang, setDefaultLang] = useState(
    window.localStorage.getItem("activeLang") || "en"
  );
  const [isAppBackground, setIsAppBackground] = useState(false);

  //Slices
  const generalDetails = useGeneralDetails();

  //UseEffect
  useEffect(() => {
    // ChangeHistory("push", ROUTE_PATH.SAMPLES.LANDING);
    if (document.addEventListener)
      document.addEventListener("visibilitychange", visibilityChanged);
    EventManager.initialise();
  }, []);

  const visibilityChanged = () => {
    console.log({
      appState: document.hidden ? "Background" : "Foreground",
      visibilityState: document.visibilityState,
    });
    if (
      !document.hidden &&
      store?.getState()?.routing?.data?.routeInfo?.[0]?.kycDone
    ) {
      //do something
    }
    setIsAppBackground(document.hidden);
  };

  return (
    <LanguageContext.Provider
      value={[
        defaultLang,
        (lang: string) => {
          setDefaultLang(lang);
        },
      ]}
    >
      <div className="app">
        <LanguageSupport
          visible={generalDetails?.showChangeLanguageScreen}
          onClose={() =>
            setGeneralDetails({
              showChangeLanguageScreen: false,
            })
          }
        />
        <div className="router">
          <Routes />
          <Loader />
        </div>
      </div>
    </LanguageContext.Provider>
  );
};

export default App;
